<template>
    <div class="w-[100vw] h-[100vh] fixed top-[-200px] left-0 flex justify-center items-center bg-[#0000005a]">
        <div class=" text-[var(--text)] gap-4 p-4 bg-[var(--fundoApp)] rounded-[10px]  flex flex-col">
            <div class="w-full flex gap-2 justify-between items-center">
                <h3 class="text-[var(--titulo)]">{{ edit_mode ? title : 'Visualizar' }}</h3>
                <div class="flex gap-2 items-center">
                    <AppButton v-if="edit_mode" v-bind:visibility="true" :font_size="12" color="var(--button)"
                        left_icon="fa-solid fa-pen-to-square" :text="button_text" emitType="select"
                        @select="save_config" />
                    <AppButton style="color: var(--icon);" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
                        emitType="close" @close="close" :width="23" :height="23" />
                </div>
            </div>
            <div class="flex flex-col gap-2">
                <div v-for="(value, key) in modelCopy" :key="key">
                    <div v-if="key === 'descricao' || key === 'observacao'" class="flex flex-col gap-1">
                        <label :for="key" class="capitalize">{{ formatLabel(key) }}:</label>
                        <textarea
                            :readonly="!edit_mode"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] resize-none w-96 h-80"
                            v-model="modelCopy[key]"
                            :placeholder="key"
                        ></textarea>
                    </div>
                    <div v-else class="flex gap-1">
                        <label class="min-w-36 capitalize" :for="key">{{ formatLabel(key) }}:</label>
                        <div v-if="key === 'conetividade'">
                            <select v-model="modelCopy[key]" class="bg-white text-black rounded-[5px]">
                                <option
                                    v-for="(connValue, cKey) in conetividade_list"
                                    :key="cKey"
                                    :value="connValue"
                                >
                                    {{ connValue }}
                                </option>
                            </select>
                        </div>
                        <input
                            v-else
                            class="text-black text-[10px] min-w-32 border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40"
                            :type="getInputType(value, key)"
                            v-model="modelCopy[key]"
                            :placeholder="key"
                            :class="{ 'input-required': isEmptyField(key) }"
                        />
                    </div>
                </div>
            </div>

            <!-- Attachments -->
            <div v-if="attachment" class="flex flex-col gap-2">
                <label class="text-[var(--icon)]">Anexos:</label>
                <input type="file" class="text-[var(--text)] text-[10px] border-1 border-[var(--label)] p-1 rounded-[5px] w-96"
                    @change="handleFileChange" multiple accept=".pdf">
                <!-- Optional: show selected file names -->
                <div v-if="attachmentCopy && attachmentCopy.length > 0">
                    <p class="text-sm mt-1">Ficheiros selecionados:</p>
                    <ul>
                        <li v-for="file in attachmentCopy" :key="file.name" class="text-[var(--icon)]">
                            {{ file.name }}
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="attachments && attachments.length > 0" class="mt-2 overflow-y-auto" style="max-height: 8.5rem;">
                <p class="text-sm text-[var(--icon)]">Ficheiros anexados:</p>
                <ul>
                    <li
                        v-for="(file, index) in attachments"
                        :key="index"
                        class="flex items-center gap-2"
                    >
                        <span>{{ file }}</span>
                        <button @click="viewAttachment(file)">
                            <i class="fa-solid fa-eye text-[var(--icon)]"></i>
                        </button>
                    </li>
                </ul>
            </div>

            <!-- setData container -->
            <div class="set_data_container rounded-[10px] flex gap-4 bg-[#5d5d988c]">
                <div v-for="(value, key) in setDataCopy" :key="key">
                    <div v-if="key !== 'endereco' && key !== 'contrato'" class="ser_data flex items-center gap-1">
                        <label :for="key">{{ formatLabel(key) }}:</label>
                        <div class="text-[#ff9b05]">
                            {{ value.nome ? value.nome : value.numero }}
                        </div>
                        <button
                            v-if="key !== 'cliente' && key !== 'subcliente'"
                            @click="open_dialog_alert(key)"
                            style="color: #ff9b05;"
                        >
                            <Icon class="edit-icon" icon="lucide:edit" />
                        </button>
                    </div>
                </div>
            </div>

            <!-- Checkboxes -->
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                <div
                    v-for="(cb, cbIndex) in checkBoxesCopy"
                    :key="cbIndex"
                    class="flex gap-2 items-center"
                >
                    <input type="checkbox" :id="cb.name" :value="cb.value" v-model="cb.value" />
                    <label :for="cb.name" class="capitalize">
                        {{ cb.name }}
                    </label>
                    <div v-if="cb.value && cb.name === 'Faturação Agregada'">
                        <select v-model="listChoiceCopy" class="bg-white text-black rounded-[5px]">
                            <option v-for="(opVal, opIndex) in listBox" :key="opIndex" :value="opVal">
                                {{ opVal }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <component
        v-if="showDialog"
        :is="isTecnico ? 'DialogTecnico' : 'Dialog'"
        :propsData="dialogProps"
        @close="closeDialog"
        @returnData="handleReturnData"
    />
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import { toast } from "vue3-toastify";
import Dialog from "@/components/dialog/dinamicDialog.vue";
import DialogTecnico from "@/components/dialog/dinamicDialogTecnico.vue";

export default {
    name: "genericPopUp",
    components: {
        AppButton,
        Dialog,
        DialogTecnico
    },
    props: {
         isTecnico: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Title"
        },
        model: {
            type: Object,
            default: () => ({})
        },
        checkBoxes: {
            type: Array,
            default: () => []
        },
        listBox: {
            type: Array,
            default: () => []
        },
        listChoice: {
            type: String,
            default: "0"
        },
        setData: {
            type: Object,
            default: () => ({})
        },
        edit_mode: {
            type: Boolean,
            default: true
        },
        button_text: {
            type: String,
            default: "Salvar"
        },
        all_mandatory: {
            type: Boolean,
            default: false
        },
        mandatory_fields: {
            type: Array,
            default: () => []
        },
        attachment: {
            type: Boolean,
            default: false
        },
        attachments: {
            type: Array,
            default: () => []
        },
        
    },
    data() {
        return {
            listChoiceCopy: JSON.parse(JSON.stringify(this.listChoice)),
            checkBoxesCopy: JSON.parse(JSON.stringify(this.checkBoxes)),
            setDataCopy: JSON.parse(JSON.stringify(this.setData)),
            modelCopy: JSON.parse(JSON.stringify(this.model)),
            attachmentCopy: [],
            showDialog: false,
            currentType: null,
            conetividade_list: ["gprs", "wifi", "nenhum"],
            dialogProps: {
                entity: ["equipamento", "tpiva", "tpmoeda"],
                sideBar: true,
                multi: false,
                queryParams: { equipamento: "custom=1" }
            }
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },
        save_config() {
            if (this.all_mandatory) {
                const emptyFields = Object.keys(this.modelCopy).filter((key) => {
                    return this.isEmptyField(key);
                });
                if (emptyFields.length > 0) {
                    toast("Preencha todos os campos obrigatórios", {
                        theme: "auto",
                        type: "warning",
                        position: "top-center",
                        autoClose: 1000
                    });
                    return;
                }
            } else if (this.mandatory_fields.length > 0) {
                const emptyFields = this.mandatory_fields.filter((key) => {
                    return this.isEmptyField(key);
                });
                if (emptyFields.length > 0) {
                    toast("Preencha todos os campos obrigatórios", {
                        theme: "auto",
                        type: "warning",
                        position: "top-center",
                        autoClose: 1000
                    });
                    return;
                }
            }

            let returnVal = false;
            this.checkBoxesCopy.forEach((checkBox) => {
                if (
                    checkBox.name === "Faturação Agregada" &&
                    checkBox.value &&
                    this.listChoiceCopy === "0"
                ) {
                    toast("Escolha uma opção para Faturação Agregada", {
                        theme: "auto",
                        type: "warning",
                        position: "top-center",
                        autoClose: 1000
                    });
                    returnVal = true;
                } else if (
                    checkBox.name === "Faturação Agregada" &&
                    !checkBox.value
                ) {
                    this.listChoiceCopy = "0";
                }
            });

            if (returnVal) {
                return;
            }

            this.$emit("save", this.checkBoxesCopy, this.listChoiceCopy, this.setDataCopy);
            this.$emit("save_form", this.modelCopy, this.setDataCopy);

            if (this.attachment && this.attachmentCopy.length > 0) {
                this.$emit("save_attachments", this.attachmentCopy, this.modelCopy);
            }
        },
        open_dialog_alert(key) {
            if (key === "iva") {
                this.dialogProps.entity[0] = "tpiva";
                this.currentType = "tpiva";
                this.showDialog = true;
            } else if (key === "zona") {
                this.dialogProps.entity[0] = "tpzona";
                this.currentType = "tpzona";
                this.showDialog = true;
            } else if (key === "tabelaPrecos") {
                this.dialogProps.entity[0] = "precario";
                this.currentType = "precario";
                this.showDialog = true;
            }
        },
        handleReturnData(data) {
            if (data.tpiva) {
                this.setDataCopy.iva.nome = data.tpiva.nome;
                this.setDataCopy.iva.id = data.tpiva.id;
            } else if (data.tpzona) {
                this.setDataCopy.zona.nome = data.tpzona.nome;
                this.setDataCopy.zona.id = data.tpzona.id;
            } else if (data.precario) {
                this.setDataCopy.tabelaPrecos.nome = data.precario.nome;
                this.setDataCopy.tabelaPrecos.id = data.precario.id;
            }
        },
        closeDialog() {
            this.showDialog = false;
        },
        getInputType(value, key) {
            const lowerKey = key.toLowerCase();
            if (lowerKey.includes("data") || lowerKey.includes("date")) {
                return "date";
            }
            if (lowerKey.includes("hora") || lowerKey.includes("time")) {
                return "time";
            }
            return typeof value === "number" ? "number" : "text";
        },
        handleFileChange(event) {
            this.attachmentCopy = event.target.files;
        },
        isEmptyField(field) {
            // If we have specific mandatory fields, check those
            if (this.mandatory_fields.length > 0) {
                if (
                    this.mandatory_fields.includes(field) &&
                    (
                        this.modelCopy[field] == null ||
                        this.modelCopy[field] === "" ||
                        this.modelCopy[field] === 0
                    )
                ) {
                    return true;
                }
            }
            // If all fields are mandatory, check all
            if (this.all_mandatory) {
                if (
                    this.modelCopy[field] == null ||
                    this.modelCopy[field] === "" ||
                    this.modelCopy[field] === 0
                ) {
                    return true;
                }
            }
            return false;
        },
        viewAttachment(file) {
            this.$emit("view_attachment", file);
        },
        formatLabel(key) {
            return key.replace(/([A-Z])/g, " $1");
        }
    },
    watch: {
        checkBoxes: {
            handler(newVal) {
                this.checkBoxesCopy = newVal;
            },
            deep: true
        },
        listChoice: {
            handler(newVal) {
                this.listChoiceCopy = newVal;
            },
            deep: true
        },
        setData: {
            handler(newVal) {
                this.setDataCopy = newVal;
            },
            deep: true
        },
        model: {
            handler(newVal) {
                this.modelCopy = newVal;
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.text-white {
    color: var(--label);
}
</style>
